@if (screenSize === 'large') {
  @if(breadcrumbs){
    <nav>
      <ol class="breadcrumbs">
        @for(breadcrumb of breadcrumbs; track breadcrumb.nextUrl){
        <li>
          <a [routerLink]="useRouter ? breadcrumb.nextUrl : null">{{
            breadcrumb.label
          }}</a>
        </li>
        }
      </ol>
    </nav>
    }
}
